import React, { useState, useRef } from "react";
import { Button } from "theme-ui";
import { Icon } from "./Icon";
import logo from "../assets/images/logo.svg"
import { NavLink as RouterLink } from "react-router-dom";
import { useLiquity } from "src/hooks/LiquityContext";

export const SideNav: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const overlay = useRef<HTMLDivElement>(null);
  const { liquity: { connection } } = useLiquity()
  const assertTokenIsMock = connection._assetTokenIsMock

  if (!isVisible) {
    return (
      <Button sx={{ display: ["flex", "none"] }} variant="icon" onClick={() => setIsVisible(true)}>
        <Icon name="bars" size="lg" color='white'/>
      </Button>
    );
  }
  return (
    <div className="fixed left-0 top-0 w-screen h-screen blcosk bg-overlay" ref={overlay} onClick={e => {
        if (e.target === overlay.current) {
          setIsVisible(false);
        }
      }}>
      <div className="flex flex-col bg-card h-full mr-[25vw]">
        <Button
          sx={{ position: "fixed", right: "25vw", m: 2 }}
          variant="icon"
          onClick={() => setIsVisible(false)}
        >
          <Icon name="times" size="sm" color="white"/>
        </Button>
        <img src={logo} alt="PSY logo" className="w-24 m-4"/>

        <nav className="flex flex-col ml-6 mt-4 text-style-value" onClick={() => setIsVisible(false)}>
          <RouterLink to="/">Dashboard</RouterLink>
          <RouterLink to="/products" className="mt-4">Borrow</RouterLink>
          <RouterLink to="/stability-pools" className="mt-4">Stability Pools</RouterLink>
          <RouterLink  to="/risky-troves" className="mt-4">Risky Troves</RouterLink>
          {assertTokenIsMock && (
            <RouterLink to="/faucet" className="mt-4">
              Faucet
            </RouterLink>
          )}
        </nav>
      </div>
    </div>
  );
};
